// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__3NedV"};